module.exports = __webpack_public_path__ + "img/pdf-icon.8c720e22.svg";